@let globalAssignmentKpisWithTranslations =
  (globalAssignmentKpisWithTranslations$ | async) || [];

<div class="kpi-card d-flex align-items-center">
  <div
    class="global-kpi-counter-parent"
    [ngClass]="{
      'expanded-width':
        isKPICardOpen && globalAssignmentKpisWithTranslations.length > 3,
      collapsed: !isKPICardOpen,
    }"
  >
    <div class="global-kpi-counter-scroll">
      <ng-container
        *rxFor="
          let kpi of globalAssignmentKpisWithTranslations;
          trackBy: 'translatedName'
        "
      >
        <div class="kpi-counter-section me-1">
          <div class="d-flex">
            <div class="kpi-content-wrapper">
              <div
                nz-tooltip
                [nzTooltipTitle]="kpi.translatedDescription"
                class="value-container"
              >
                <div
                  #valueElement
                  [ngClass]="
                    isLoadingUserAssignmentKpi
                      ? 'kpi-counter-loading-text '
                      : 'kpi-counter-text value-text'
                  "
                  class="p-0 m-0 value-text"
                  title="{{ kpi.value }}"
                >
                  {{ kpi.value }}
                </div>

                <p
                  class="kpi-averages-header-text custom-ellipses p-0 m-0"
                  title="{{ kpi.translatedName | translate }}"
                  [style.width.px]="valueElement.offsetWidth"
                >
                  {{ kpi.translatedName }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
